<template>
  <sonko-layout>
    <vue-headful title="eWak" />
    <experts-list :experts="loadExperts"></experts-list>
    
    <v-pagination class="ml-2 mt-2" v-if="experts.length>=1"
        v-model="currentPage"
        :length="Math.ceil(amount/perPage)"
    ></v-pagination>
  </sonko-layout>
</template>

<script>
import { mapGetters } from "vuex";
import ExpertsList from "./_components/experts.vue";
export default {
  name: "SonkoLandingPage",
  components: {
    ExpertsList
  },
  computed: {
    ...mapGetters(["user"]),
    loadExperts() {
      return this.experts.slice((this.currentPage*this.perPage - this.perPage), ((this.currentPage*this.perPage - this.perPage)+this.perPage))
    }
  },
  data() {
    return {
      experts: [],
      /*currentPage: typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1,
      perPage: 12,*/
      amount: 0,
      currentPage: 1,
      perPage: 12,
    };
  },
  created() {
    let cPage = typeof this.$route.query.page != "undefined"
        ? this.$route.query.page
        : 1;
      const expertiseData = this.user.expertise;
      const expertiseArray = [];
      for (const expertise of expertiseData) {
        expertiseArray.push(expertise.category);
      }
      const exString = expertiseArray.join("|");
      const eData = {
        category: exString,
        location: this.user.locationOne,
        page: cPage,
        userId: this.user._id
      };
      const data = { queryData: JSON.stringify(eData) };

      this.$store.dispatch("post", { url: "/expert/find-in-locations", data }).then(res => {
        this.experts = res.experts;
        this.amount = res.amount;
      });
  },
  methods: {
    fetchExperts() {
      let cPage = typeof this.$route.query.page != "undefined"
        ? this.$route.query.page
        : 1;
      const expertiseData = this.user.expertise;
      const expertiseArray = [];
      for (const expertise of expertiseData) {
        expertiseArray.push(expertise.category);
      }
      const exString = expertiseArray.join("|");
      const eData = {
        category: exString,
        location: this.user.locationOne,
        page: cPage,
        userId: this.user._id
      };
      const data = { queryData: JSON.stringify(eData) };

      this.$store.dispatch("post", { url: "/expert/find-in-locations", data }).then(res => {
        this.experts = res.experts;
        this.amount = res.amount;
      });
    },
    onPageChange(page) {
      this.$router.push({query: {page: page}});
      this.fetchExperts();
    }
  }
};
</script>
